<template>
  <span>
    'Хочу, хочу, хочу!'. Мы постоянно загадываем желания.
    Трем носы и пальцы городским достопримечательностям, портим праздничное шампанское, ловим "22:22"
    на часах. А они, заветные, все не сбываются. Что делать и как с этим бороться? Очень просто.
    Перестать на них фокусироваться. Отправить запрос и заниматься своими делами.
    Он обязательно дойдет куда надо и запишется на исполнение. Для этого всего лишь нужно
    сформулировать его очень-очень конкретно, в позитивной формулировке (без всяких "не"),
    записать в окошко сверху, нажать кнопку <SendButton/> и <em>забыть</em>.
    Космос позаботится о Ваших желаниях. <span>Он уже начал.</span>
  </span>
</template>

<script>
  import SendButton from './SendButton'

  export default {
    name: 'StandardTip',
    components: {
      SendButton
    }
  }
</script>

<style scoped>

</style>